(function () {
  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function getDailyTarget(now, resetHour, resetMinute) {
    var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), resetHour, resetMinute, 0, 0);
    if (target <= now) {
      target.setDate(target.getDate() + 1);
    }
    return target;
  }

  function parseDate(value) {
    if (!value) return null;
    var date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  function initTopbarCountdown(root) {
    var countdownEl = root.querySelector('[data-topbar-countdown]');
    if (!countdownEl) return;

    var hoursEl = countdownEl.querySelector('[data-topbar-hours]');
    var minutesEl = countdownEl.querySelector('[data-topbar-minutes]');
    var secondsEl = countdownEl.querySelector('[data-topbar-seconds]');
    var mode = countdownEl.dataset.mode;
    var resetHour = parseInt(countdownEl.dataset.resetHour, 10) || 0;
    var resetMinute = parseInt(countdownEl.dataset.resetMinute, 10) || 0;
    var startDate = parseDate(countdownEl.dataset.start);
    var endDate = parseDate(countdownEl.dataset.end);

    function tick() {
      var now = new Date();

      if (mode === 'fixed') {
        if (!endDate || (startDate && now < startDate) || now >= endDate) {
          root.classList.add('tp-topbar-text--hidden');
          return;
        }
        root.classList.remove('tp-topbar-text--hidden');
        renderDiff(endDate - now);
        return;
      }

      // modo diário: recalcula sempre o próximo horário de reset
      var target = getDailyTarget(now, resetHour, resetMinute);
      renderDiff(target - now);
    }

    function renderDiff(diffMs) {
      var totalSeconds = Math.floor(Math.max(0, diffMs) / 1000);
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    tick();
    setInterval(tick, 1000);
  }

  document.querySelectorAll('[data-tp-topbar-text]').forEach(initTopbarCountdown);
})();
